<div class="bg-blue-500 flex min-h-screen items-center justify-center">
  <div class="bg-white w-full md:w-8/12 xl:w-4/12 p-6 rounded-lg shadow-md m-4">
    <img title="Pet Pets" src="/assets/logos/logo-flat.svg" alt="Pet Pets logos" class="mx-auto w-[250px] mb-8" />
    <p class="font-semibold mr-2 text-gray-700 mb-8">
      Digite seu e-mail para receber um link de recuperação de senha
    </p>
    <app-forgot-password-form [(isLoading)]="isLoading" (onSubmit)="forgotPassword($event)" />
  </div>
</div>